import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserHelper } from '../../../helpers/user.helper';
import { Organization } from '../../../models/identity/organization.model';
import { User } from '../../../models/identity/user.model';
import { ImageService } from '../../../services/shared/image.service';

@Component({
    selector: 'app-user-directory-profile-card',
    templateUrl: './user-directory-profile-card.component.html',
    styleUrls: ['./user-directory-profile-card.component.scss'],
})
export class UserDirectoryProfileCardComponent {
    @Input() profile: User;
    @Input() isAdminProfile: boolean;
    @Input() isActive = false;
    @Output() cardClick = new EventEmitter<string>();
    public userOrganization: Organization;
    public activeCardUserId: string | null = null;

    public dataLoaded$: Promise<boolean>;
    constructor(
        public imageService: ImageService,
        public readonly userHelper: UserHelper,
    ) {}
    toggleActive(userId: string): void {
        this.cardClick.emit(userId);
    }
}
